import { t } from '@framework/i18n';
import {
  SearchableFieldGroup,
  SearchableFieldType,
  type SearchableField,
} from '@framework/ui';

export const archivedSubmissionSearchableFields: SearchableField[] = [
  {
    type: SearchableFieldType.Text,
    label: t('archived-submissions.search.subject', 'Oggetto'),
    name: 'oggetto',
    placeholder: t('archived-submissions.search.subject', 'Oggetto') + '...',
    group: SearchableFieldGroup.Filters,
  },
  {
    type: SearchableFieldType.Text,
    label: t('archived-submissions.search.protocol', 'Numero Protocollo'),
    name: 'protocollo',
    placeholder:
      t('archived-submissions.search.protocol', 'Numero Protocollo') + '...',
    group: SearchableFieldGroup.Filters,
  },
  {
    type: SearchableFieldType.DateRange,
    label: t('archived-submissions.search.sentDate', 'Data Invio'),
    name: 'dataInvio',
    from: {
      name: 'dataInvioDal',
      label: t('archived-submissions.search.data-invio-dal', 'Dal'),
    },
    to: {
      name: 'dataInvioAl',
      label: t('archived-submissions.search.data-invio-al', 'Al'),
    },
    group: SearchableFieldGroup.Filters,
  },
];
